import {createTextVariant} from './Text.js'

export default createTextVariant('s1', 'S1')
